// Header search island (SPEC-01): renders the same GET form the server
// emitted, so behavior is identical with and without JS. Autocomplete and
// last-query suggestions land with SPEC-04.
import { useState } from "react";

export default function SearchBox({ query = "", market = "us", platform = "", placeholder = "Search apps…", ariaLabel = "Search applications" }) {
  const [value, setValue] = useState(query);
  return (
    <form className="pub-search" action="/apps" method="get" role="search">
      <svg className="pub-search__icon" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="8" /><path d="m21 21-4.3-4.3" /></svg>
      <input
        type="search"
        name="q"
        value={value}
        onChange={(event) => setValue(event.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel}
        autoComplete="off"
      />
      {market && market !== "us" ? <input type="hidden" name="market" value={market} /> : null}
      {platform ? <input type="hidden" name="platform" value={platform} /> : null}
    </form>
  );
}
